<div class="min-h-[70vh] flex items-center justify-center px-4 py-10 bg-gray-200">

  <div class="w-full max-w-2xl">

    <!-- Title -->
    <div class="text-center mb-8">
      <h2 class="text-2xl md:text-3xl font-semibold text-[#c19725]">
        Reset Password
      </h2>
      <p class="text-gray-500 text-sm mt-2">
        Enter your new password below
      </p>
    </div>

    <!-- Card -->
    <div class="bg-white rounded-2xl shadow-lg p-6 md:p-10">

      <form>

        <!-- Email -->
        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-600 mb-2">
            Email
          </label>
          <input readonly type="email"
            [(ngModel)]="email"
            name="email"
            class="w-full border border-gray-300 rounded-lg bg-gray-200 px-4 py-2 focus:border-[#c19725] focus:ring-1 focus:ring-[#c19725] outline-none transition"
            readonly />
        </div>

        <!-- New Password -->
        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-600 mb-2">
            New Password
          </label>
          <input type="password"
            [(ngModel)]="password"
            name="password"
            class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:border-[#c19725] focus:ring-1 focus:ring-[#c19725] outline-none transition" />
        </div>

        <!-- Confirm Password -->
        <div class="mb-8">
          <label class="block text-sm font-medium text-gray-600 mb-2">
            Confirm Password
          </label>
          <input type="password"
            [(ngModel)]="master_password"
            name="master_password"
            class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:border-[#c19725] focus:ring-1 focus:ring-[#c19725] outline-none transition" />
        </div>

        <!-- Button -->
        <button type="button"
          (click)="updatePassword()"
          class="w-full bg-[#c19725] hover:bg-[#a67f1f] text-white font-semibold py-2.5 rounded-lg transition duration-200 shadow-md hover:shadow-lg">
          Update Password
        </button>

      </form>

    </div>
  </div>
</div>